import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StepAction } from '@telespot/domain';

export type GenerateFinding = StepAction.ASSET_CREATED | StepAction.USER_CAPTURE | 'never';

@Component({
  selector: 'ts-generate-finding-selector',
  templateUrl: './generate-finding-selector.component.html',
  styleUrls: ['./generate-finding-selector.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenerateFindingSelectorComponent {
  @Input() value: GenerateFinding | null = null;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<GenerateFinding>();

  public readonly ON_ASSET_CREATED = StepAction.ASSET_CREATED;
  public readonly ON_USER_CAPTURE = StepAction.USER_CAPTURE;
  public readonly NEVER: GenerateFinding = 'never';

  onChange(event: Event): void {
    const next = (event.target as HTMLSelectElement).value as GenerateFinding;
    this.valueChange.emit(next);
  }
}
